export default {
  login: "auth/login",
  requestCredentials: "auth/request-credentials",
  sendResetPasswordLink: "auth/reset-password",
  setPassword: "auth/set-password",
  logout: "auth/logout",
  user: `auth/user`,
  verify: `auth/search`,
  sendOtp: `auth/sendOtp`,
  verifyOtp: `auth/verify`,
};
